import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import GiftSvg from '../../assets/icons/gift.svg';
import HLBCampaignInfoModal from './HLBCampaignInfoModal';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class HLBCampaignCalloutBanner extends Component {
  static propTypes = {
    t: PropTypes.func,
  }
  constructor(props) {
    super(props);
    this.state = {
      openInfoModal: false,
    };
  }
  handleFindOutMore = async () => {
    this.setState({ openInfoModal: true });
  }
  handleOnCloseInfo = () => {
    this.setState({ openInfoModal: false });
  }

  render() {
    const { t } = this.props;

    return (
      <div className="hlb-campaign-callout-banner">
        <div className="hlb-campaign-callout-banner-text">
          <img src={GiftSvg} width={20} alt="gift" />
          <span>
            <strong>{t('MHub Rewards', { ns: TRANSLATION_FILES.translation })}:</strong>&nbsp;&nbsp;
            {t('Get RM10 from MHub for every case you send to Hong Leong Bank!*', { ns: TRANSLATION_FILES.translation })}
          </span>
        </div>
        <Button
          className="hlb-campaign-callout-banner-button"
          content={t('Find out more', { ns: TRANSLATION_FILES.translation })}
          onClick={this.handleFindOutMore}
        />
        <HLBCampaignInfoModal
          show={this.state.openInfoModal}
          handleOnClose={this.handleOnCloseInfo}
        />
      </div>
    );
  }
}

export default withTranslation(namespaces)(HLBCampaignCalloutBanner);



// WEBPACK FOOTER //
// ./src/components/HLBCampaign/HLBCampaignCalloutBanner.jsx